<template>
  <div class="login-page">
    <Login />
  </div>
</template>
<script>
import Login from 'pc/components/login.vue'
import cookies from '@/utils/cookie'
export default {
  name: "loginPage",
  components: {
    Login
  },
  created() {
    if (this.$route.query.redirectUrl) {
      cookies.set('loginRedirectUrl', this.$route.query.redirectUrl)
      this.$once('hook:beforeDestroy', () => {
        cookies.remove('loginRedirectUrl')
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.login-page {
  height: 100%;
  padding-top: 100px;
  @media (max-width: 768px) {
    background-color: $--color-white;
  }
}
</style>